module.exports = __webpack_public_path__ + "resources/feature-icon-1-844f3c05174dc8c9d078a2a384877b99.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/feature-icon-1.png
// module id = 77
// module chunks = 0